


















import { Component, Prop, Vue } from 'vue-property-decorator';
import PerformanceWidget from '@/components/organisms/Performance/PerformanceWidget/index.vue';
import PerformanceWidgetSimpleContent
  from '@/components/organisms/Performance/PerformanceWidgetSimpleContent/index.vue';

@Component({
  name: 'PerformanceWidgetRegionOccupancyRate',
  components: {
    PerformanceWidget,
    PerformanceWidgetSimpleContent,
  },
})
export default class PerformanceWidgetRegionOccupancyRate extends Vue {
  @Prop() protected locked!: any;

  @Prop() protected loading!: any;

  @Prop() protected value!: any;
}
